"use client";
export const dynamic = "force-dynamic";

import Link from "next/link";
import { useEffect, useState } from "react";
import { ArrowRight, Tag } from "lucide-react";
import { getCategory, getPublishedPosts } from "@/lib/blog/store";
import PostCard from "@/components/blog/PostCard";
import { BlogListSkeleton } from "@/components/blog/BlogSkeleton";
import { useParams } from "next/navigation";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>() as { slug: string };
  const { cat } = {} as any;
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 600);
    return () => clearTimeout(t);
  }, []);

  if (loading) return <BlogListSkeleton />;

  const posts = getPublishedPosts().filter((p) => p.categoryId === cat.id);

  return (
    <div className="fade-in">
      <section className="border-b border-border bg-gradient-to-br from-primary-main/5 to-secondary-main/5">
        <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 sm:py-16">
          <Link
            href="/blog"
            className="mb-4 inline-flex items-center gap-1.5 text-xs font-bold text-muted-foreground hover:text-primary-main"
          >
            <ArrowRight size={12} />
            همه مقالات
          </Link>
          <div className="flex items-center gap-3">
            <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-card shadow-md">
              <Tag size={20} className={cat.color} />
            </span>
            <div>
              <p className={`text-xs font-black uppercase tracking-wider ${cat.color}`}>
                دسته‌بندی
              </p>
              <h1 className="text-2xl font-black text-foreground sm:text-4xl">{cat.name}</h1>
            </div>
          </div>
          <p className="mt-4 max-w-2xl text-sm text-muted-foreground sm:text-base">
            {cat.description}
          </p>
          <p className="mt-3 text-xs text-muted-foreground">
            {posts.length.toLocaleString("fa-IR")} مقاله در این دسته
          </p>
        </div>
      </section>

      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6">
        {posts.length === 0 ? (
          <div className="rounded-2xl border border-dashed border-border bg-card py-20 text-center">
            <p className="text-sm font-bold text-foreground">هنوز مقاله‌ای منتشر نشده</p>
          </div>
        ) : (
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {posts.map((p) => (
              <PostCard key={p.id} post={p} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
